module.exports = __webpack_public_path__ + "static/flags/HA-2f1d19e2cacdcafc01644606cf21b6c0.gif";